import React, { useEffect, useState } from 'react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(12 * 60); // 12 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <div className="w-full bg-[#0d1225] py-2 z-20 relative border-b border-white/5" data-id="element-48">
      <div className="max-w-[980px] mx-auto px-4 flex items-center justify-center gap-3 text-sm" data-id="element-49">
        <span className="text-white/80 font-medium" data-id="element-50">⏰ Oferta termina en:</span>
        <span className="text-[#22c55e] font-black text-lg tracking-wider tabular-nums" data-id="element-51">
          {minutes}:{seconds}
        </span>
      </div>
    </div>;
}